import { Route, Routes } from "react-router-dom";
import AdminNavbar from "../Components/adminNav";
import TopNav from "../Components/adminTopNav";
import Dashboard from "./Admin Pages/Dashboard";
import Users from "./Admin Pages/users";
import ManageTours from "./Admin Pages/manageTours";
import TourRequests from "./Admin Pages/TourRequests";
import ManageBlog from "./Admin Pages/manageBlogs";
import ManageAframe from "./Admin Pages/manageAframe";
import ManageContacts from "./Admin Pages/manageContacts";

const Admin = () => {
  return (
    <>
      <div className="admin-container">
        <AdminNavbar />
        <div className="admin-content">
          <TopNav />
          <Routes>
            <Route path="/" element={<TourRequests />} />
            <Route path="/users" element={<Users />} />
            <Route path="/tours" element={<ManageTours/>} /> 
            <Route path="/requests" element={<TourRequests/>} /> 
            <Route path="/blogs" element={<ManageBlog/>} /> 
            <Route path="/contacts" element={<ManageContacts/>} /> 
            {/* <Route path="/aframes" element={<ManageAframe/>} />  */}
          </Routes>
        </div>
      </div>
    </>
  );
};

export default Admin;
